<template>
  <div class="error" v-if="loading == 'error'">
    Erreur...
  </div>
  <div class="loading" v-if="loading == true">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" fill="none" stroke="#75C6C3" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
      </circle>
    </svg>
  </div> 
  <div class="moteur" v-if="loading == false">
    <div :class="'moteurl show_map_'+ this.showmap +' show_filtres_'+ this.showfiltres">
      <NavOffres 
        :showmap="showmap" 
        :showfiltres="showfiltres" 
        :pagination="pagination" 
        :api="comtourismeapi" 
        :geoloc="this.geoloc" 
        :wishlist="this.wishlist"
        v-on:showMap="showMapAttr"
        v-on:showFiltres="showFiltresAttr">
      </NavOffres>
      <GlobalFiltres
        v-show="showfiltres"
        :offres="render"
        :selectedFilters="selectedFilters"
        :api="comtourismeapi">
      </GlobalFiltres>
      <ListeOffres
        :showfiltres="showfiltres"
        :showmap="showmap"
        :offres="render"
        :pagination="pagination"
        :api="comtourismeapi"
        :geoloc="geoloc">
      </ListeOffres>
    </div>
    <div class="moteurr" v-if="showmap == true">
      <MapOffres
        :offres="render"
        :geoloc="geoloc">
      </MapOffres>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import NavOffres from './components/NavOffres.vue';
import ListeOffres from './components/ListeOffres.vue';
import MapOffres from './components/MapOffres.vue';
import GlobalFiltres from './components/GlobalFiltres.vue';
import axios from 'axios';

export default {
  name: 'App',
  data: function() {
    return {
      comtourismeapi: {
        api: comtourismeplugin.api,
        rest: comtourismeplugin.rest,
        ajax: comtourismeplugin.ajax,
        type: comtourismeplugin.type,
        per_page: comtourismeplugin.per_page,
        lang: comtourismeplugin.lang,
        mapbox_key: comtourismeplugin.mapbox_key,
        mapbox_center: comtourismeplugin.mapbox_center,
        mapbox_style: comtourismeplugin.mapbox_style,
        nonce: comtourismeplugin.nonce,
        wishlist_link: comtourismeplugin.wishlist_link,
        dates: comtourismeplugin.dates
      }, 
      showmap:true,
      showfiltres:false,
      offres:[],
      filtres:[],
      globalfiltres:[],
      selectedFilters: {},
      loading:true,
      pagination : {
        current: 1,
        total: null,
        page: 1
      },
      geoloc:false,
      wishlist: [],
      wishlist_id: null
    }
  },
  components: {
    NavOffres,
    GlobalFiltres,
    ListeOffres,
    MapOffres
  },
  methods : {
    getCookie(name) {
      const cookieArr = document.cookie.split(";");
      for(let i = 0; i < cookieArr.length; i++) {
          const cookiePair = cookieArr[i].split("=");
          if(name == cookiePair[0].trim()) {
              return decodeURIComponent(cookiePair[1]);
          }
      }
      return null;
    },
    async getWishlist(wishlist_cookie) {
      this.wishlist_id = wishlist_cookie;
      axios
      .get(this.comtourismeapi.rest+'comtourisme-wishlist/v1/wishlist/?id='+this.wishlist_id+'&lang='+this.comtourismeapi.lang)
      .then(response => (this.syncWishlist(response.data)))
      .catch(() => {
      }) 
    },
    syncWishlist(wishlist) {
      let wishlist_syndic = [];
      for(let e=0; e< wishlist.length; e++) {
        wishlist_syndic[e] = wishlist[e].syndication_id;
      }
      this.wishlist = wishlist_syndic;
    },
    async getOffres() {
      axios.get(this.comtourismeapi.rest+'comtourisme/v1/moteur/?moteur_id='+this.comtourismeapi.type+'&lang='+this.comtourismeapi.lang)
      .then(response => (this.OffresChargees(response)))
      .catch(function () {

      })
      .finally(function () {
        
      });
    },
    OffresChargees(response) {
      // Méthode déclenchée lorsque l'appel axios est ok
      if(response.data) {
        this.offres = response.data.posts;
        this.filtres = response.data.filters;
        this.globalfiltres = response.data.moteur_filters;
        this.loading = false;
      }
    },
    updateMoteur(offres) { 
      this.pagination.current = 1;
      this.pagination.total = offres.length;
      this.pagination.page = Math.ceil(this.pagination.total / this.comtourismeapi.per_page);
      return offres;
    },
    checkFilter(type, offre) {
      const filters = this.selectedFilters[type];
      if (filters.length === 0 || filters === false) {
        return true;
      }
      if (Array.isArray(filters)) {
        if (type == 'notempty') {
          return filters.some(filter => {
              const field = filter.field;
              return offre.acf[field] !== undefined && offre.acf[field] !== "";
          });
        }
        else if (type === 'metas') {
          return selectedFilters.some(filter => {
              const field = filter.field;
              const value = Boolean(filter.value);
              return offre.acf[field] === value;
          });
        }
        else if(type === 'post_type') {
          return filters.includes(offre.type);
        }
        else {
          return offre.taxonomy[type]?.some(i => filters.includes(i)) || false;
        }
      } else {
        return offre.acf[type] === filters || false;
      }
    },
    checkCapacity(type, offre) {
      if (this.selectedFilters[type].length === 0 || this.selectedFilters[type] == false || parseInt(this.selectedFilters[type][0].value) == 0) {
        return true;
      }

      return this.selectedFilters[type].some(filter => {
        const field = filter.field;
        const value = parseInt(filter.value);

        return parseInt(offre.acf[field]) >= value;
      });
    },
    checkResto(type, offre) {
      let statut = false;
      let periode;
      if(this.selectedFilters[type] == 'null') { return true; }
      if(offre.acf.OUVERTUREDATESs !== undefined) {
        // On vérifie qu'il y ait des périodes d'ouvertures
        let informations = offre.acf.OUVERTUREDATESs;
        let now = new Date().toISOString().slice(0, 10);
        for(let i=0; i<informations.length; i++) {
          let start = informations[i].Datedebut.split(' ')[0];
          let end = informations[i].Datefin.split(' ')[0];
          start = start.split('/');
          start = start[2]+'-'+start[1]+'-'+start[0];
          end = end.split('/');
          end = end[2]+'-'+end[1]+'-'+end[0];

          if(now >= start && now <= end) {
            // On récupére la dernière période pour écraser par exemple une période annuelle.
            periode = informations[i];
          }
        }
        if(periode) {
          let days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
          let dayName = days[new Date().getDay()];
          for(let e=0; e<periode.OUVERTUREs.length; e++) {
            let day = periode.OUVERTUREs[e];
            if(day.etat == 'open') {  
              if(day.jour == dayName && (this.selectedFilters[type] == 'midi' || this.selectedFilters[type] == 'soir')) {
                  if(this.selectedFilters[type] == 'midi' && day.matin == true) {
                    statut = true;
                  }
                  else if(this.selectedFilters[type] == 'soir' && day.soir == true) {
                    statut = true;
                  }
                  break;
              }
            }
            if(this.selectedFilters[type] == 'dimanche' && day.jour == 'dimanche' && (day.matin == true || day.soir == true)) {
              statut = true;
              break;
            }
          }
        }
      }
      return statut;
    },
    checkDates(type, offre) {
      if (
        this.selectedFilters[type].length === 2 &&
        this.comtourismeapi.dates
      ) {
        const [date1, date2] = this.selectedFilters[type].map((date) => {
          // Normaliser les dates sélectionnées pour ignorer les heures
          const normalizedDate = new Date(date);
          normalizedDate.setHours(0, 0, 0, 0);  // Fixer les heures à minuit
          return normalizedDate;
        });

        return offre.acf.DATESs.some(({ Datededebut, Datedefin }) => {
          const start = new Date(Datededebut);
          const end = new Date(Datedefin);

          // Normaliser les dates de l'événement pour ignorer les heures
          start.setHours(0, 0, 0, 0);
          end.setHours(0, 0, 0, 0);

          // Inclure les événements qui commencent ou se terminent pendant la période sélectionnée,
          // ou ceux qui ont la même date de début et de fin que le filtre
          return (start <= date2 && end >= date1);
        });
      } else {
        return true;
      }
    },

    checkGeo(type, offre, userPos) {
      // Recherche par coordonnées GPS
      let statut = false; 
      let offreData = {latitude:Number(offre.acf.GmapLatitude), longitude:Number(offre.acf.GmapLongitude)};
      let userData = {latitude:userPos.lat, longitude:userPos.lng};
      if(this.calcDistance(userData, offreData) <= 10) {
        statut = true;
      }
      
      return statut;
    },
    degreesToRadians(degrees) {
      var radians = (degrees * Math.PI)/180;
      return radians;
    },
    calcDistance (startingCoords, destinationCoords){
      let startingLat = this.degreesToRadians(startingCoords.latitude);
      let startingLong = this.degreesToRadians(startingCoords.longitude);
      let destinationLat = this.degreesToRadians(destinationCoords.latitude);
      let destinationLong = this.degreesToRadians(destinationCoords.longitude);

      let radius = 6571;

      let distanceInKilometers = Math.acos(Math.sin(startingLat) * Math.sin(destinationLat) +
      Math.cos(startingLat) * Math.cos(destinationLat) *
      Math.cos(startingLong - destinationLong)) * radius;
      return distanceInKilometers;
    },
    reOrderOffres(offres) {
      var newoffres;
      if(
        this.comtourismeapi.type == 17188 
        || this.comtourismeapi.type == 19240 
        || this.comtourismeapi.type == 19241
        || this.comtourismeapi.type == 18964
        || this.comtourismeapi.type == 19541
        || this.comtourismeapi.type == 19543
        || this.comtourismeapi.type == 18962
        || this.comtourismeapi.type == 23078
        || this.comtourismeapi.type == 23080
      ) {
        newoffres = offres;
      }
      else {
        // Affichage aléatoire des offres
        newoffres = offres.sort(() => Math.random() - 0.5);
      }
      return newoffres;
    },
    geoLocSearch(position) {
      if(position !== false) {
        this.geoloc = {};
        this.geoloc.lat = position.coords.latitude;
        this.geoloc.lng = position.coords.longitude;
        this.selectedFilters['geo'] = [position.coords.latitude, position.coords.longitude];
      }
      else {
        this.geoloc = false;
        delete this.selectedFilters.geo;
      }
    },
    showMapAttr(status) {
      this.showmap = status;
    },
    showFiltresAttr(status) {
      this.showfiltres = status;
    },
    checkOffer(offer) {
      for (const type in this.selectedFilters) {
        switch (type) {
          case 'date':
            if (!this.checkDates(type, offer)) return false;
            break;
          case 'geo':
            if (!this.checkGeo(type, offer, this.geoloc)) return false;
            break;
          case 'open':
            if (!this.checkResto(type, offer)) return false;
            break;
          case 'capacites':
            if (!this.checkCapacity(type, offer)) return false;
            break;
          default:
            if (!this.checkFilter(type, offer)) return false;
        }
      }
      return true;
    }
  }, 
  created() {
    this.getOffres();
    if(this.getCookie('wishlist')) {
      this.getWishlist(this.getCookie('wishlist'));
    }
  },
  computed : {
    render() {
      const offres = this.offres.filter(offer => this.checkOffer(offer));
      const newOffres = this.reOrderOffres(offres);
      this.updateMoteur(newOffres);
      return newOffres;
    }
  }
}
</script>